import React, { useEffect, useState } from 'react';
import Countdown from './Countdown';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import './Navigation1.css';

const Navigation2 = ({actionLink, actionLinkName}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const { language, switchLanguage } = useLanguage();
  const t = translations[language].navigation;

  const controlNavbar = () => {
    if (window.scrollY > lastScrollY) {
      // Scroll down
      setIsVisible(false);
    } else {
      // Scroll up
      setIsVisible(true);
    }
    setLastScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', controlNavbar);
    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [lastScrollY]);

  return (
    <div>
      <header className={`navigation-header ${isVisible ? 'visible' : 'hidden'}`}>
        <div className="navigation-menu">
            <Countdown />
        </div>
      </header>
      <div className={`navigation-logo-container ${isVisible ? 'visible' : 'hidden'}`}>
        <img src="../img/bonusclub_logo.webp" alt="Logo" className="navigation-logo-fixed" />
        <span className="navigation-ai-badge">AI</span>
      </div>
      <img src="../img/icon.png" alt="Icon" className={`navigation-icon-fixed ${isVisible ? 'hidden' : 'visible'}`} />
      <div className="fixed-button-container">
        <div className="country-switch-container">
          <button 
            className={`country-switch-button ${language === 'en' ? 'active' : ''}`}
            onClick={() => switchLanguage('en')}
          >
            <img src="../img/usa.svg" alt="English" className="country-flag" />
            <span>EN</span>
          </button>
          <button 
            className={`country-switch-button ${language === 'de' ? 'active' : ''}`}
            onClick={() => switchLanguage('de')}
          >
            <img src="../img/germany.svg" alt="Deutsch" className="country-flag" />
            <span>DE</span>
          </button>
        </div>
        <a href="https://calendly.com/salesgod/scaleup-team-call" target="_blank" rel="noopener noreferrer" className="learn-more-link">{t.login}</a>
      </div>
    </div>
  );
};

export default Navigation2;
